import EmberRouter from '@ember/routing/router';
import config from 'login/config/environment';

export default class Router extends EmberRouter {
  override location = config.locationType;
  override rootURL = config.rootURL;
}

Router.map(function () {
  this.route('forgot-password', { path: 'forgotPassword' });
  this.route('change-password', { path: 'changePassword' });
  this.route('set-password', { path: 'setPassword' });
  this.route('expired');
  this.route('disconnected');
  this.route('register-user', { path: 'registerUser' });
});
